import { LOAD_TEXT_ALERT_SETTINGS_PAGE, LOAD_SAVE_TEXT_ALERT_PREFERENCES } from 'constants/ActionTypes';
import { all, takeLatest } from 'lib/redux';
import loadTextAlertSettingsSaga, { saveTextAlertSettingsSaga } from './TextAlertSettings.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_TEXT_ALERT_SETTINGS_PAGE, loadTextAlertSettingsSaga),
    takeLatest(LOAD_SAVE_TEXT_ALERT_PREFERENCES, saveTextAlertSettingsSaga),
  ]);
}
